import {useEffect} from 'react'
import {signinRedirectCallback} from '../../Authorization/authService'
import LoadingIndicator from '../Loading/index'
import {useHistory} from 'react-router-dom'

const SigninOidc = () => {
  const history = useHistory()
  useEffect(() => {
    async function signinAsync() {
      await signinRedirectCallback()
      history.push('/Home')
    }

    signinAsync()
  }, [history])

  return (
      <LoadingIndicator props={true}/>
  )
}

export default SigninOidc
